module.exports = __webpack_public_path__ + "static/img/u7.ca4e5420.png";